import Action from '../Action';

export function updateActiveTab(key) {
	return (dispatch) => dispatch({ type: Action.UPDATE_ACTIVE_KEY, activeTabKey: key });
}

export function updateSidebarTab(key) {
	return (dispatch) => dispatch({ type: Action.UPDATE_SIDEBAR_KEY, activeSidebarKey: key });
}
